var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigitaltoolsRafiki(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-102"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,337.8H45.3a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,45.3,55H238.4a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,238.4,337.8ZM45.3,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H238.4a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.7,337.8H261.6a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,261.6,55H454.7a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,454.7,337.8ZM261.6,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H454.7a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.19 371.94 133.82 349.47 132.49 349.47 123.26 371.94 125.19 371.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.47 372.06 139.27 355.89 138.22 355.65 126.95 371.71 128.47 372.06",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.53 371.88 78.9 349.41 80.23 349.41 89.47 371.88 87.53 371.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.25 372 73.45 355.83 74.5 355.59 85.77 371.65 84.25 372",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.03 369.42 106.14 369.42 106.65 343.89 107.52 343.89 108.03 369.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.88 371.88 88.33 372.88 89.61 372.88 89.2 371.88 87.88 371.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.86 371.88 124.42 372.88 123.13 372.88 123.54 371.88 124.86 371.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.6 371.94 85.21 373.08 86.47 373.08 85.38 371.74 84.6 371.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.16 371.94 127.55 373.08 126.29 373.08 127.38 371.74 128.16 371.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.41 369.42 106.41 371.47 107.76 371.47 107.76 369.42 106.41 369.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.66,
    y: 378.76,
    width: 5.34,
    height: 3.33,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.88,
    y: 378.76,
    width: 5.34,
    height: 3.33,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.09,380.23l-11.6,1.26a102.51,102.51,0,0,1-22.15,0l-11.61-1.26V373l9.43-1.22a102.28,102.28,0,0,1,26.51,0l9.42,1.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.32,374.68a2.15,2.15,0,1,0,2.16,2.16A2.15,2.15,0,0,0,88.32,374.68Zm0,3.45a1.28,1.28,0,0,1,0-2.56,1.28,1.28,0,1,1,0,2.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5,376.85a.68.68,0,1,1-.68-.68A.68.68,0,0,1,100.5,376.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.92,376.85a.68.68,0,1,1-.68-.68A.68.68,0,0,1,102.92,376.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.34,376.85a.68.68,0,0,1-1.36,0,.68.68,0,0,1,1.36,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.76,376.85a.68.68,0,0,1-1.36,0,.68.68,0,0,1,1.36,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.19,376.85a.68.68,0,1,1-.68-.68A.68.68,0,0,1,110.19,376.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.61,376.85a.68.68,0,1,1-.68-.68A.67.67,0,0,1,112.61,376.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,376.85a.68.68,0,0,1-1.36,0,.68.68,0,0,1,1.36,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.33,379.89l-6.85-15.17h-16l2.46,14.21a1.28,1.28,0,0,1-1.26,1.5h-7a.67.67,0,0,0-.68.68v.75a.67.67,0,0,0,.68.68h28.18a.74.74,0,0,0,.73-.74V381A2.73,2.73,0,0,0,400.33,379.89Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.23,379.89l-6.85-15.17h-.9l6.85,15.17a2.73,2.73,0,0,1,.24,1.13v.78a.74.74,0,0,1-.73.74h.9a.74.74,0,0,0,.74-.74V381A2.59,2.59,0,0,0,401.23,379.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.48 364.73 377.47 364.73 378.1 368.35 395.11 368.35 393.48 364.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,366.32H349.71a2.25,2.25,0,0,1-2.28-2.5l4.32-49.34a2.78,2.78,0,0,1,2.71-2.5h68.29a2.25,2.25,0,0,1,2.28,2.5l-4.32,49.34A2.78,2.78,0,0,1,418,366.32Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.9,358.48l-.47,5.34a2.25,2.25,0,0,0,2.28,2.5H418a2.78,2.78,0,0,0,2.72-2.5l.47-5.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.77,357h-68.2a1.22,1.22,0,0,1-1.23-1.36l3.57-40.78a1.49,1.49,0,0,1,1.47-1.35h68.19a1.22,1.22,0,0,1,1.24,1.35l-3.57,40.78A1.52,1.52,0,0,1,418.77,357Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.26,312h-1.51a2.25,2.25,0,0,1,2.28,2.5l-4.32,49.34a2.78,2.78,0,0,1-2.72,2.5h1.51a2.78,2.78,0,0,0,2.72-2.5l4.32-49.34A2.25,2.25,0,0,0,424.26,312Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.7,381.11v.72a.71.71,0,0,1-.71.71H371.66a.67.67,0,0,1-.68-.68v-.75a.67.67,0,0,1,.68-.68h7a1.15,1.15,0,0,0,.26,0H395A.71.71,0,0,1,395.7,381.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.5,380.4H378.93a1.28,1.28,0,0,0,1-1.23h20Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "397.21 356.45 399.84 356.45 408.95 313.58 408.97 313.49 406.35 313.49 406.32 313.58 397.21 356.45",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.71 356.45 394.56 356.45 403.67 313.58 403.69 313.49 393.84 313.49 393.82 313.58 384.71 356.45",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "353.76 378.12 381.57 378.12 381.57 382.64 325.95 382.64 325.95 380.79 353.76 378.12",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.76 382.64 381.57 382.64 381.57 378.12 353.76 380.79 353.76 382.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.73,
    y: 199.82,
    width: 41.37,
    height: 41.37,
    rx: 11.01,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.07,227.21a2.37,2.37,0,0,1-1.57-1.51c-.71-1.86-1-9.61.28-11.17a2.53,2.53,0,0,1,1.65-.9c3.51-.38,14.35-.33,15.6.13a2.43,2.43,0,0,1,1.53,1.47c.76,1.92.87,8.92,0,10.76a2.37,2.37,0,0,1-1.09,1.12C420.27,227.79,406.8,227.78,405.07,227.21Zm3.75-1.76,9.35-4.87-9.47-4.91c0,3.26.07,6.51.12,9.78Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.1,
    y: 198.99,
    width: 41.43,
    height: 41.43,
    rx: 11.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.62,
    y: 207.42,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.66,
    y: 207.42,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 207.42,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.62,
    y: 208.46,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.62,
    y: 209.5,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.62,
    y: 231.11,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.62,
    y: 230.07,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.62,
    y: 229.03,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.66,
    y: 231.11,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 231.11,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.06,
    y: 207.42,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.06,
    y: 208.46,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.06,
    y: 209.5,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.02,
    y: 207.42,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.98,
    y: 207.42,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.01,
    y: 231.11,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.01,
    y: 230.07,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.01,
    y: 229.03,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.97,
    y: 231.11,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.93,
    y: 231.11,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 209.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.74,
    y: 209.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.78,
    y: 209.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.82,
    y: 209.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.85,
    y: 209.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.89,
    y: 209.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 209.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 210.85,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 210.85,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 211.89,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.78,
    y: 211.89,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.82,
    y: 211.89,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.85,
    y: 211.89,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 211.89,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 212.93,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.78,
    y: 212.93,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.82,
    y: 212.93,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.85,
    y: 212.93,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 212.93,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 213.97,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.78,
    y: 213.97,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.82,
    y: 213.97,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.85,
    y: 213.97,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 213.97,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 215.01,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 215.01,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 216.05,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.74,
    y: 216.05,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.78,
    y: 216.05,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.82,
    y: 216.05,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.85,
    y: 216.05,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.89,
    y: 216.05,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 216.05,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.69,
    y: 209.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.73,
    y: 209.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.77,
    y: 209.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.81,
    y: 209.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.85,
    y: 209.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.89,
    y: 209.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.93,
    y: 209.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.69,
    y: 210.85,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.93,
    y: 210.85,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.69,
    y: 211.89,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.77,
    y: 211.89,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.81,
    y: 211.89,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.85,
    y: 211.89,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.93,
    y: 211.89,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.69,
    y: 212.93,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.77,
    y: 212.93,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.81,
    y: 212.93,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.85,
    y: 212.93,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.93,
    y: 212.93,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.69,
    y: 213.97,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.77,
    y: 213.97,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.81,
    y: 213.97,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.85,
    y: 213.97,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.93,
    y: 213.97,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.69,
    y: 215.01,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.93,
    y: 215.01,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.69,
    y: 216.05,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.73,
    y: 216.05,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.77,
    y: 216.05,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.81,
    y: 216.05,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.85,
    y: 216.05,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.89,
    y: 216.05,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.93,
    y: 216.05,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.89,
    y: 225.93,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.89,
    y: 226.96,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.89,
    y: 228,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.85,
    y: 225.93,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.85,
    y: 226.96,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.85,
    y: 228,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.81,
    y: 225.93,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.77,
    y: 225.93,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.73,
    y: 224.89,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.73,
    y: 223.85,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.73,
    y: 226.96,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.73,
    y: 228,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 222.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.74,
    y: 222.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.78,
    y: 222.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.82,
    y: 222.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.85,
    y: 222.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.89,
    y: 222.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 222.81,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 223.85,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 223.85,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 224.89,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.78,
    y: 224.89,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.82,
    y: 224.89,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.85,
    y: 224.89,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 224.89,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 225.93,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.78,
    y: 225.93,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.82,
    y: 225.93,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.85,
    y: 225.93,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 225.93,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 226.96,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.78,
    y: 226.96,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.82,
    y: 226.96,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.85,
    y: 226.96,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 226.96,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 228,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 228,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 229.04,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.74,
    y: 229.04,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.78,
    y: 229.04,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.82,
    y: 229.04,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.85,
    y: 229.04,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.89,
    y: 229.04,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 229.04,
    width: 1.04,
    height: 1.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.1,
    y: 63.58,
    width: 41.43,
    height: 41.43,
    rx: 11.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.48,84.27A5.48,5.48,0,1,1,247,78.8,5.49,5.49,0,0,1,252.48,84.27Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.13,76.15H236a3.7,3.7,0,0,0-3.7,3.69v8.87A3.7,3.7,0,0,0,236,92.4h22.16a3.69,3.69,0,0,0,3.69-3.69V79.84A3.69,3.69,0,0,0,258.13,76.15ZM247,91.25a7,7,0,1,1,7-7A7,7,0,0,1,247,91.25Zm11.05-11.41h-3.63V77.9h3.63Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.69,74.63h.52a1,1,0,0,1,1,1v.84a0,0,0,0,1,0,0h-2.53a0,0,0,0,1,0,0v-.84A1,1,0,0,1,237.69,74.63Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-102"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-102",
    cx: 250,
    cy: 412.39,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-102"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.75,407.2h-.09a.5.5,0,0,1-.4-.58c0-.16,3.09-15.43,14.35-24,8.59-6.58,17.75-21.56,17.84-21.71a.5.5,0,0,1,.69-.17.51.51,0,0,1,.17.69c-.1.15-9.35,15.29-18.09,22-11,8.39-14,23.29-14,23.43A.49.49,0,0,1,290.75,407.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.2,387.19s11.6-2.36,7.57,4.71-13.29,4-13.29,4-7.91-5.21-3.87-11.52S303.2,387.19,303.2,387.19Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.61,384.41c4-6.31,9.59,2.78,9.59,2.78s.84,4.54-5.72,8.74C297.48,395.93,289.57,390.72,293.61,384.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.44,361.16s7.36-6.78,7.53.1-7.84,8.73-7.84,8.73-8-.31-7.84-6.64S322.44,361.16,322.44,361.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.29,363.35c.16-6.32,8.15-2.19,8.15-2.19s2.59,2.92-.31,8.83C322.13,370,314.13,369.68,314.29,363.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.13,374s2.89-9.58-3.37-6.74-4.44,10.86-4.44,10.86,3.77,7.07,9.39,4.17S313.13,374,313.13,374Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.71,382.27c5.62-2.9-1.58-8.29-1.58-8.29s-3.76-1.07-7.81,4.12C305.32,378.1,309.09,385.17,314.71,382.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.16,407.2a.51.51,0,0,1-.47-.33c-.05-.14-4.79-13.36-16.28-20.59-11.74-7.4-17.06-16.58-17.11-16.67a.5.5,0,1,1,.87-.5c.05.09,5.25,9.07,16.78,16.32,11.78,7.42,16.64,21,16.68,21.11a.49.49,0,0,1-.3.63A.51.51,0,0,1,281.16,407.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.35,407.2h0a.5.5,0,0,1-.46-.54c0-.11.85-11.56,1.76-22.29s5.54-16.92,5.73-17.17a.5.5,0,0,1,.79.61c-.05.07-4.64,6.08-5.53,16.64-.9,10.73-1.74,22.17-1.75,22.29A.5.5,0,0,1,283.35,407.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.07,376.53s3.38-7.43-4.86-5.5-5.38,8.35-5.38,8.35,5.41,5.78,12.79,3.78S286.07,376.53,286.07,376.53Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.62,383.16c7.38-2-2.55-6.63-2.55-6.63a13.69,13.69,0,0,0-10.24,2.85S281.24,385.16,288.62,383.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.89,377.81s3.38-7.42-4.86-5.5-5.39,8.36-5.39,8.36,5.42,5.77,12.8,3.77S253.89,377.81,253.89,377.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.44,384.44c7.38-2-2.55-6.63-2.55-6.63a13.7,13.7,0,0,0-10.25,2.86S249.06,386.44,256.44,384.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.44,393.74s1.65-8-6-4.29-3.4,9.35-3.4,9.35,6.56,4.43,13.31.84S272.44,393.74,272.44,393.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.39,399.64c6.75-3.58-3.95-5.9-3.95-5.9a13.73,13.73,0,0,0-9.36,5.06S269.64,403.23,276.39,399.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.21,389.32s2.3-5.06-3.32-3.75-3.67,5.69-3.67,5.69,3.69,3.94,8.72,2.58S285.21,389.32,285.21,389.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.94,393.84c5-1.37-1.73-4.52-1.73-4.52a9.35,9.35,0,0,0-7,1.94S281.91,395.2,286.94,393.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.21,367.07s-2.89-7.73,3.81-5.57,4.53,8.74,4.53,8.74-4.25,5.85-10.26,3.63S290.21,367.07,290.21,367.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.29,373.87c-6-2.23,1.92-6.8,1.92-6.8s4.08-1,8.34,3.17C298.55,370.24,294.3,376.09,288.29,373.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.18,366.44s3.29-4.83-1.68-4.47-4.58,5.25-4.58,5.25,1.94,4.73,6.44,4.21S248.18,366.44,248.18,366.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.36,371.43c4.5-.52-.18-5-.18-5s-2.65-1.35-6.26.78C241.92,367.22,243.86,372,248.36,371.43Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.92,383.29s-11.74-1.6-5.6-6.94,13.88.56,13.88.56,5.74,7.53-.14,12.16S262.92,383.29,262.92,383.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.06,389.07c-5.89,4.62-8.14-5.78-8.14-5.78s.7-4.57,8.28-6.38C271.2,376.91,276.94,384.44,271.06,389.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.3,418.43h18.94a3.73,3.73,0,0,0,3.66-3.07l2.15-12H268.48l2.16,12A3.73,3.73,0,0,0,274.3,418.43Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.3,418.43h18.94a3.73,3.73,0,0,0,3.66-3.07l2.15-12H268.48l2.16,12A3.73,3.73,0,0,0,274.3,418.43Z",
    style: {
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-102"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.1,342.08H214.8a15.42,15.42,0,0,1-15.59-16.76l13.73-196.7a18.26,18.26,0,0,1,17.94-16.76h82.29a15.43,15.43,0,0,1,15.6,16.76L315,325.32A18.24,18.24,0,0,1,297.1,342.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.1,342.08H214.8a15.42,15.42,0,0,1-15.59-16.76l13.73-196.7a18.26,18.26,0,0,1,17.94-16.76h82.29a15.43,15.43,0,0,1,15.6,16.76L315,325.32A18.24,18.24,0,0,1,297.1,342.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.83,342.08h-82.3a15.42,15.42,0,0,1-15.59-16.76l13.73-196.7a18.26,18.26,0,0,1,17.93-16.76h82.3a15.42,15.42,0,0,1,15.59,16.76l-13.73,196.7A18.26,18.26,0,0,1,292.83,342.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.63,115.7H287.24a3,3,0,0,0-2.93,2.43l-.13.67a7.42,7.42,0,0,1-7.16,5.94H256.68a6.23,6.23,0,0,1-6.32-5.94l0-.67a2.55,2.55,0,0,0-2.59-2.43h-21.4a14.05,14.05,0,0,0-13.81,12.92l-13.74,196.7a11.89,11.89,0,0,0,12,12.92h82.29a14.06,14.06,0,0,0,13.82-12.92l13.74-196.7A11.89,11.89,0,0,0,308.63,115.7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.65,128.62l-.29,4L306.92,325.32a14.08,14.08,0,0,1-13.83,12.92h-82.3a11.88,11.88,0,0,1-12-12.92l13.44-192.71.29-4a14.07,14.07,0,0,1,13.81-12.92h21.4a2.55,2.55,0,0,1,2.59,2.44l0,.66a6.24,6.24,0,0,0,6.32,5.94H277a7.41,7.41,0,0,0,7.16-5.94l.13-.66a3.05,3.05,0,0,1,2.94-2.44h21.39A11.89,11.89,0,0,1,320.65,128.62Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262.35,117.88a1.77,1.77,0,0,1-1.75,1.63,1.51,1.51,0,0,1-1.52-1.63,1.79,1.79,0,0,1,1.75-1.63A1.49,1.49,0,0,1,262.35,117.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M274.06,116.25h-5.61a1.79,1.79,0,0,0-1.75,1.63,1.51,1.51,0,0,0,1.52,1.63h5.61a1.79,1.79,0,0,0,1.75-1.63A1.51,1.51,0,0,0,274.06,116.25Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "221.75 124.71 223.48 124.71 223.6 122.98 221.87 122.98 221.75 124.71",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.33 122.98 225.21 124.71 226.94 124.71 227.06 122.98 227.18 121.25 225.45 121.25 225.33 122.98",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.03 119.52 228.91 121.25 228.79 122.98 228.67 124.71 230.4 124.71 230.52 122.98 230.64 121.25 230.76 119.52 229.03 119.52",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.45,119.63l-.09,1.27h-.85l-.17,2.54h.84l-.09,1.27h7.62l.35-5.08Zm3.12,3.81H304l.18-2.54h2.53Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-102"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "169.2 397.35 166.83 412.86 174.33 412.86 179.26 397.35 169.2 397.35",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.88,409.4l10-.23a.56.56,0,0,1,.63.55l0,7.35a1.68,1.68,0,0,1-1.65,1.51c-3.48,0-5.14-.13-9.55,0a112.69,112.69,0,0,1-14-.92c-3.57-.61-2.6-4-1-4,7.29-.26,11.36-1.78,14-3.66A2.79,2.79,0,0,1,165.88,409.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.25 403.57 169.2 397.35 179.26 397.35 176.84 405.1 168.25 403.57",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.21,310.38s-61,.61-61.93,19.92c-1.35,27.77-6,70.11-6,70.11l11.5,3.16s16.4-42,17-63.67c17.16-3.41,61.26,0,66.44-11.26a30.25,30.25,0,0,0,1.95-18.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.21,310.38s-61,.61-61.93,19.92c-1.35,27.77-6,70.11-6,70.11l11.5,3.16s16.4-42,17-63.67c17.16-3.41,61.26,0,66.44-11.26a30.25,30.25,0,0,0,1.95-18.26Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.63 395.93 150.42 408.21 155.12 414.96 166.31 402.71 158.63 395.93",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.1 407.32 166.31 402.71 159.32 394.92 154.81 401.63 162.1 407.32",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.82,407.61l6.55,4.86a.64.64,0,0,1,.26.87h0l-3.81,6.9a1.63,1.63,0,0,1-2.23.45c-3-2-4.4-3.15-8.29-5.64-2.38-1.53-5.48-3.33-8.78-5.45s-1.22-5.14.34-4.51c7.08,2.78,9.41,2.08,12.69,1.84A10.59,10.59,0,0,1,150.82,407.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.85,398.79l9,7.29s19.8-21.2,39.56-57.81l-.25-.45c17.78-1.39,66.64-6.24,72.48-13.39,6.16-7.56,5.73-16.2,3.41-24.05h-29s-46.28,6.84-61.39,21.36C178.29,341.84,155.85,398.79,155.85,398.79Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.85,398.79l9,7.29s19.8-21.2,39.56-57.81l-.25-.45c17.78-1.39,66.64-6.24,72.48-13.39,6.16-7.56,5.73-16.2,3.41-24.05h-29s-46.28,6.84-61.39,21.36C178.29,341.84,155.85,398.79,155.85,398.79Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M248,244.79l-20.1,3c-11.25,1.68-22.91-4.09-32.58-10.08l-4.67,4.88s20.49,15.14,30.69,15.18c5.78,0,14.82-1.52,21.57-2.85A7.19,7.19,0,0,0,248,244.79Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.38,228.81c.55,3.28,1.11,6.57,1.67,9.85,1.87,1.19,3.48,2.8,5.36,4a15.65,15.65,0,0,0,5-4.64c-.34-1.53-1-3-1.31-4.53-.58-2.54-3.68-4.2-5.39-6.16C187.18,227.68,184.91,228.45,183.38,228.81Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.76,260.31l-15-.4-2.07-14s8.37-1.65,16.21-3.25C243.18,247.23,243.43,255.76,243.76,260.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.76,260.31l-15-.4-2.07-14s8.37-1.65,16.21-3.25C243.18,247.23,243.43,255.76,243.76,260.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.71 259.91 242.74 257.32 242.81 260.33 228.71 259.91",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.21,311.93c-5.36,1.26-15.68.25-25.4-.11-6.76-.26-15.95-1.44-15.95-1.44.73-11.34.42-22.71-2.65-43.26-1.46-9.8,5.73-24.54,5.76-24.54,1.12-.18,2.33-.34,3.58-.49.7-.08,1.4-.14,2.12-.19a150,150,0,0,1,17.48.29c1.09.07,2.21.17,3.3.29s2,.23,2.92.37l1.29.18a6.09,6.09,0,0,1,5.07,7,.2.2,0,0,1,0,.07c-.53,4.67-1,8.78-1.25,12.53,0,.12,0,.25,0,.37-.35,4.17-.54,7.91-.57,11.49C276.76,285.68,278.12,295.36,281.21,311.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.53,261.3c0,.43,0,.87-.06,1.3,0,.12,0,.25,0,.37-.35,4.17-.54,7.91-.57,11.49-2.48-4.72-4.92-11.42-4.76-14.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.53,261.3c0,.43,0,.87-.06,1.3a1.34,1.34,0,0,0,0,.2c-.35,4.23-.55,8-.58,11.66-2.48-4.72-4.92-11.42-4.76-14.76Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.71,222.51c-1.2,5.6-2.46,15.88,1.4,19.7-3.1,3-7.15,6.42-13.83,6.55s-5.43-4.48-3.64-6.84c6.3-1.4,6.22-6,5.19-10.43Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.29,226.14l-6.43,5.31a18.16,18.16,0,0,1,.48,3.1,8.54,8.54,0,0,0,6.42-4.88C261.36,228.08,260.89,226.37,260.29,226.14Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.49,206.45a70.73,70.73,0,0,0-8.29,27.16,9.63,9.63,0,0,0,.13,3.71,3.58,3.58,0,0,0,2.49,2.56,2.11,2.11,0,0,1,.22-3.27,6.07,6.07,0,0,0,1.05,4.28,4.45,4.45,0,0,0,3.4,1.58,3.08,3.08,0,0,1-.15-1.8c.92,1.27,2.77,2,4.07,1.09,2.18-1.47,2.22-4.72,2.68-7.31l4.76-27a5.77,5.77,0,0,0-4.38-2.07,17.94,17.94,0,0,0-5,.78h.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.69,216.3c-2.35,7.26-3.37,11.62-8.06,14.44-7.07,4.24-15.3-1.49-15.14-9.33.13-7,4-17.71,11.93-18.78a10.4,10.4,0,0,1,11.27,13.67Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.8,218.2a30.56,30.56,0,0,1-1.91,4.2,13.7,13.7,0,0,1,4.73-.59,15.43,15.43,0,0,0,1.67.09,2.38,2.38,0,0,0,1.54-.59,2,2,0,0,0,.43-2A3.22,3.22,0,0,0,270,217.7a3.68,3.68,0,0,0-2.19-.67C267,217.06,265.07,217.47,264.8,218.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.28,224a6.55,6.55,0,0,1-4.69,1.78c-2.31-.08-2.76-2.3-1.53-4.11,1.1-1.63,3.63-3.54,5.65-2.58A3,3,0,0,1,270.28,224Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.27,214.6a22.31,22.31,0,0,1-4.16,4.41,3.55,3.55,0,0,0,2.72,1.27Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.35,223.24a5.16,5.16,0,0,0,3.89-1.09.19.19,0,0,0,0-.26.18.18,0,0,0-.26,0,4.89,4.89,0,0,1-4.35.85.19.19,0,0,0-.22.13h0a.19.19,0,0,0,.13.23C251.81,223.15,252.08,223.2,252.35,223.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.64,213.82a.37.37,0,0,0,.18,0,.35.35,0,0,0,.2-.46h0a3.58,3.58,0,0,0-2.49-2.2.35.35,0,0,0-.41.29h0a.37.37,0,0,0,.28.43h0a2.85,2.85,0,0,1,2,1.75A.32.32,0,0,0,260.64,213.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.88,210.64a.39.39,0,0,0,.32-.13,2.92,2.92,0,0,1,2.4-1.08.35.35,0,0,0,.4-.31.36.36,0,0,0-.3-.41h0a3.6,3.6,0,0,0-3,1.33.36.36,0,0,0,0,.51h0A.34.34,0,0,0,248.88,210.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.2,246.37c-.05,0-.13,0-.14,0-2.05,8.55-1.65,17.48-3.59,26.32-1.35,6.17-13.62,6.07-25.39,10.9l1.35,7.42s24.45-1.29,31.18-10.49c3.81-5.22,4.66-7.79,5.6-15.42,1-7.83,1.46-17.83-3.68-18.79Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.07,293.67h6.44a1.88,1.88,0,0,0,1.89-2.39l-3.58-16.83a3.13,3.13,0,0,0-2.91-2.4h-6.44a1.89,1.89,0,0,0-1.89,2.4l3.58,16.83A3.12,3.12,0,0,0,233.07,293.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.07,293.67h6.44a1.88,1.88,0,0,0,1.89-2.39l-3.58-16.83a3.13,3.13,0,0,0-2.91-2.4h-6.44a1.89,1.89,0,0,0-1.89,2.4l3.58,16.83A3.12,3.12,0,0,0,233.07,293.67Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.12,293.67h6.44a1.88,1.88,0,0,0,1.89-2.39l-3.58-16.83a3.12,3.12,0,0,0-2.91-2.4h-6.43a1.88,1.88,0,0,0-1.89,2.4l3.57,16.83A3.13,3.13,0,0,0,232.12,293.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.12,293.67h6.44a1.88,1.88,0,0,0,1.89-2.39l-3.58-16.83a3.12,3.12,0,0,0-2.91-2.4h-6.43a1.88,1.88,0,0,0-1.89,2.4l3.57,16.83A3.13,3.13,0,0,0,232.12,293.67Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.68,277h-.63a2.1,2.1,0,0,1-2-1.61l-.13-.63a1.26,1.26,0,0,1,1.27-1.61h.62a2.1,2.1,0,0,1,1.95,1.61l.14.63A1.26,1.26,0,0,1,234.68,277Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.13,274.14a.87.87,0,0,0,.81.67.52.52,0,0,0,.52-.67.86.86,0,0,0-.8-.66A.52.52,0,0,0,233.13,274.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.54,276.07a.86.86,0,0,0,.81.66.51.51,0,0,0,.52-.66.87.87,0,0,0-.81-.67A.52.52,0,0,0,233.54,276.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.11,290.06c.65.56,8.86,1.33,11.32,1,.75-2.22.09-4.47-.28-6.78-1.4-1.06-3-1.87-4.39-2.92-2.32-1.75-5.67-.93-8.55-1.37-.64.86-.83,2.95-.75,4.77A7.46,7.46,0,0,0,233.11,290.06Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.14,246.66c-.16,9.76.37,9.94-1.15,19.58l16.5-1.26s1.75-7-.13-13c-1.39-4.43-3.87-8.39-9.2-9.47C271.68,242,268.19,243.65,268.14,246.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.14,246.66c-.16,9.76.37,9.94-1.15,19.58l16.5-1.26s1.75-7-.13-13c-1.39-4.43-3.87-8.39-9.2-9.47C271.68,242,268.19,243.65,268.14,246.66Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.19,224.2a1.06,1.06,0,0,1-.89.66,5.75,5.75,0,0,1-.83-.06c-1.09-.12-2.86-.4-3.14-.48-1.44-3-.69-5.51-2.86-8,.7.33,1.39.6,2.07.87s1.34.52,2,.85c1.06,1.56,2.4,3.4,3.33,5A1.49,1.49,0,0,1,276.19,224.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.31,208a15.44,15.44,0,0,1-.23,5.94,7.74,7.74,0,0,1-4.45-5,4.71,4.71,0,0,0,.43,2.84,5.15,5.15,0,0,1-3.31-3.76,4,4,0,0,0,0,2.53,4,4,0,0,1-3.25-3,2.28,2.28,0,0,0-.33,1.88,3.14,3.14,0,0,1,1-5.84,8.84,8.84,0,0,1,5.62.78A20.78,20.78,0,0,1,264.31,208Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.76,224.52a1.05,1.05,0,0,1-.91.67,5.86,5.86,0,0,1-.84-.06c-1.12-.13-2.93-.41-3.21-.49-1.48-3-.71-5.64-2.93-8.2.72.34,1.42.61,2.12.89s1.37.53,2.08.87c1.07,1.6,2.45,3.48,3.4,5.14A1.5,1.5,0,0,1,276.76,224.52Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.76,224.52a1.05,1.05,0,0,1-.91.67,5.86,5.86,0,0,1-.84-.06q-2.16-3.51-4.56-6.84c.17-.35.36-.66.54-1,.68.27,1.37.53,2.08.87,1.07,1.6,2.45,3.48,3.4,5.14A1.5,1.5,0,0,1,276.76,224.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,217.9s-1.13,2.54-1.13,2.61c-.12-.19-.26-.39-.4-.59a106.68,106.68,0,0,0-8.24-10.06c-3.49-2.82-7.71-5.36-13.07-2.72.67-1.88,6.45-15.78,19.16-5.39a17.28,17.28,0,0,1,5.18,6.93A9.81,9.81,0,0,1,273,217.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.73,206a1.87,1.87,0,0,0-.18-2.08,3.33,3.33,0,0,0-1.88-1.11,3.42,3.42,0,0,0-2.17.09,2.06,2.06,0,0,0-1.29,1.67,8.42,8.42,0,0,1,5.38,1.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,215.48c-.18.59-.6,1-1,.9s-.58-.67-.43-1.27.6-1,1-.91S258.14,214.88,258,215.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.52,214.46s0,.13-.08.14a.23.23,0,0,1-.17-.07,2.34,2.34,0,0,1-.69-.9,4.31,4.31,0,0,0,1,.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.2,213.72c-.18.6-.59,1-1,.9s-.59-.67-.43-1.27.59-1,1-.89S251.36,213.12,251.2,213.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.63,212.72c.05.05,0,.14-.07.14a.24.24,0,0,1-.18-.07,2.34,2.34,0,0,1-.69-.9,5,5,0,0,0,1,.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.38,219.05a5.24,5.24,0,0,0-3.19-2.47l-3-.82a3.35,3.35,0,0,0-6.4-1.91,1,1,0,0,0-.71-.19,3.29,3.29,0,1,0-.1.48.53.53,0,0,1,.66.18,3.35,3.35,0,0,0,6.44,1.85l3,.83a4.85,4.85,0,0,1,2.93,2.26l.7,1.24.38-.21ZM249,216a2.93,2.93,0,1,1,3.6-2.06A2.93,2.93,0,0,1,249,216Zm7.14,1.95a2.94,2.94,0,1,1,3.6-2.06A2.93,2.93,0,0,1,256.12,217.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.91,231.2c0,2.89-.21,5.9-1.73,8.34-2.29,3.63-7,5-11.27,4.89a3.45,3.45,0,0,0,2.91-2.35,7,7,0,0,1-3.67.29,3,3,0,0,0,1.93-1.83,9.11,9.11,0,0,0,.52-2.7c.79-9.32,1.64-18.85,2.43-28.17a22.7,22.7,0,0,1,2.91,2.93,61.92,61.92,0,0,1,5.16,6.73C271.12,219.43,271.92,227.45,271.91,231.2Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notification--inject-102"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155.12,
    y: 84.45,
    width: 41.43,
    height: 41.43,
    rx: 11.03,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.93,114.57a2.2,2.2,0,1,1-4.39,0v-.21h4.38A1.48,1.48,0,0,1,177.93,114.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.63,95.34a1.47,1.47,0,1,1,2.88,0,1,1,0,0,1,0,.17h-2.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.85,113.58h-18l1.27-3.24h.07V102.9a7.5,7.5,0,0,1,5.07-7.21,10.07,10.07,0,0,1,5.37,0,8.2,8.2,0,0,1,2.66,1.73,7.72,7.72,0,0,1,2.25,5.43v7.44h.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--App--inject-102"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.89,
    y: 129.11,
    width: 41.43,
    height: 41.43,
    rx: 11.03,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.89,
    y: 129.11,
    width: 41.43,
    height: 41.43,
    rx: 11.03,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,155.39a5,5,0,0,1-4.6-3.39,4.86,4.86,0,0,0,2.11-.07h.06a4.94,4.94,0,0,1-4-4.84,4.79,4.79,0,0,0,2.14.59,5,5,0,0,1-2-3,4.83,4.83,0,0,1,.48-3.54,14.21,14.21,0,0,0,10.16,5.11,2.44,2.44,0,0,0-.09-.54,4.79,4.79,0,0,1,.68-3.2,4.59,4.59,0,0,1,3.29-2.16,4.81,4.81,0,0,1,4.27,1.36.23.23,0,0,0,.26.08,9.38,9.38,0,0,0,2.83-1.09h.07a4.93,4.93,0,0,1-1.94,2.55,9.25,9.25,0,0,0,2.71-.74h0c-.18.25-.36.5-.55.74a9.33,9.33,0,0,1-1.75,1.69.15.15,0,0,0-.09.15,13.1,13.1,0,0,1-.11,2.17,14.1,14.1,0,0,1-1.2,4.34,13.8,13.8,0,0,1-2.6,3.86,13,13,0,0,1-6.7,3.75,15.9,15.9,0,0,1-2.73.33,14.11,14.11,0,0,1-7.85-2.11l-.13-.07a10,10,0,0,0,4.9-.68A9.39,9.39,0,0,0,107,155.39Z",
    style: {
      fill: "#407BFF",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Document--inject-102"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.25,
    y: 264.17,
    width: 41.43,
    height: 41.43,
    rx: 11.03,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.69,278.27l0,18.39a.42.42,0,0,1-.42.43l-17,0a.43.43,0,0,1-.43-.43l0-23.92a.43.43,0,0,1,.43-.43l11.45,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.69,278.27l0,18.39a.42.42,0,0,1-.42.43l-17,0a.43.43,0,0,1-.43-.43l0-23.92a.43.43,0,0,1,.43-.43l11.45,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.71,272.31v5.54a.43.43,0,0,0,.43.43h5.53Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.71,272.31v5.54a.43.43,0,0,0,.43.43h5.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.55,
    y: 281.59,
    width: 14.49,
    height: 0.9,
    rx: 0.39,
    transform: "translate(-1.35 0.63) rotate(-0.28)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.57,
    y: 285.28,
    width: 14.49,
    height: 0.9,
    rx: 0.39,
    transform: "translate(-1.37 0.63) rotate(-0.28)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.58,
    y: 288.97,
    width: 14.49,
    height: 0.9,
    rx: 0.39,
    transform: "translate(-1.39 0.63) rotate(-0.28)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.61,292.63l-6.64.07a.38.38,0,0,0-.38.39v.12a.39.39,0,0,0,.39.39l6.63-.07a.39.39,0,0,0,.39-.39V293A.4.4,0,0,0,129.61,292.63Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--digital-signature--inject-102"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.45,
    y: 189.62,
    width: 41.43,
    height: 41.43,
    rx: 11.03,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.45,
    y: 189.62,
    width: 41.43,
    height: 41.43,
    rx: 11.03,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.81,
    y: 195.46,
    width: 19.03,
    height: 29.07,
    rx: 2.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.74,219.28l-1.83.33.45-1.8,9.42-8.81a1,1,0,0,1,1.42.05h0a1,1,0,0,1,0,1.42Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.72,221.44a1.27,1.27,0,0,1-.92-.36,1.67,1.67,0,0,1,0-2.11,6.41,6.41,0,0,1,2-2.06,4,4,0,0,1,1.36-.6,1.15,1.15,0,0,0-.34-.42c-.74-.57-1.91-.09-2.7.5a9,9,0,0,0-3,4.05.52.52,0,0,1-.65.3.5.5,0,0,1-.29-.65,10.08,10.08,0,0,1,3.38-4.51c1.11-.82,2.72-1.39,3.89-.49a2.26,2.26,0,0,1,.8,1.22,1.92,1.92,0,0,1,1.57,1.84,2.55,2.55,0,0,1-.35,1.11c0,.09-.09.18-.13.27a.77.77,0,0,0-.06.68.48.48,0,0,0,.53,0,2.49,2.49,0,0,0,.67-.79.51.51,0,0,1,.69-.16.5.5,0,0,1,.15.69,3.17,3.17,0,0,1-1,1.12,1.42,1.42,0,0,1-1.8-.21,1.6,1.6,0,0,1-.09-1.73c0-.1.09-.2.14-.3a1.89,1.89,0,0,0,.26-.7.85.85,0,0,0-.5-.72,3.25,3.25,0,0,1-.2.83,6.91,6.91,0,0,1-1.83,2.37,3,3,0,0,1-1,.73A1.71,1.71,0,0,1,167.72,221.44Zm2.62-4.13a3.11,3.11,0,0,0-1,.44,5.46,5.46,0,0,0-1.71,1.74c-.19.32-.32.73-.17.88a.49.49,0,0,0,.45,0,2.43,2.43,0,0,0,.67-.52,6.22,6.22,0,0,0,1.59-2A2,2,0,0,0,170.34,217.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.06,
    y: 199.16,
    width: 14.49,
    height: 0.9,
    rx: 0.39,
    transform: "translate(-0.96 0.82) rotate(-0.28)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.07,
    y: 202.85,
    width: 14.49,
    height: 0.9,
    rx: 0.39,
    transform: "translate(-0.97 0.82) rotate(-0.28)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.09,
    y: 206.54,
    width: 14.49,
    height: 0.9,
    rx: 0.39,
    transform: "translate(-0.99 0.82) rotate(-0.28)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.12,210.2l-6.64.07a.38.38,0,0,0-.38.39v.12a.39.39,0,0,0,.39.39l6.63-.07a.38.38,0,0,0,.38-.39v-.12A.38.38,0,0,0,169.12,210.2Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Maps--inject-102"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.47,
    y: 65.01,
    width: 41.43,
    height: 41.43,
    rx: 11.03,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.47,
    y: 65.01,
    width: 41.43,
    height: 41.43,
    rx: 11.03,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.34,71.28a9.51,9.51,0,0,0-9.51,9.51c0,5.26,9.51,18.64,9.51,18.64s9.51-13.38,9.51-18.64A9.51,9.51,0,0,0,317.34,71.28Zm.08,14.08a4.5,4.5,0,1,1,4.51-4.5A4.5,4.5,0,0,1,317.42,85.36Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chat--inject-102"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.78,
    y: 109.57,
    width: 41.37,
    height: 41.37,
    rx: 11.01,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.78,
    y: 109.57,
    width: 41.37,
    height: 41.37,
    rx: 11.01,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1,123.67v5.83a4.37,4.37,0,0,1-4.37,4.37h-5.56l-6.35,6.35v-6.35a4.37,4.37,0,0,1-4.37-4.37v-5.83a4.37,4.37,0,0,1,4.37-4.36h11.91A4.36,4.36,0,0,1,388.1,123.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.32,141.43v-7.09A4.88,4.88,0,0,1,367,129.5v-5.83a4.87,4.87,0,0,1,4.87-4.86h11.91a4.87,4.87,0,0,1,4.87,4.86v5.83a4.88,4.88,0,0,1-4.87,4.87h-5.35Zm.5-21.62a3.87,3.87,0,0,0-3.87,3.86v5.83a3.88,3.88,0,0,0,3.87,3.87h.5V139l5.65-5.64h5.76a3.87,3.87,0,0,0,3.87-3.87v-5.83a3.86,3.86,0,0,0-3.87-3.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.49,132.46v4.48a3.36,3.36,0,0,1-3.36,3.36v4.89l-4.89-4.89H387a3.36,3.36,0,0,1-3.36-3.36v-4.48A3.37,3.37,0,0,1,387,129.1h9.17A3.37,3.37,0,0,1,399.49,132.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.63,146.4l-5.6-5.6H387a3.86,3.86,0,0,1-3.86-3.86v-4.48A3.86,3.86,0,0,1,387,128.6h9.17a3.86,3.86,0,0,1,3.86,3.86v4.48a3.87,3.87,0,0,1-3.36,3.83ZM387,129.6a2.86,2.86,0,0,0-2.86,2.86v4.48A2.86,2.86,0,0,0,387,139.8h4.49l4.18,4.18V139.8h.5a2.87,2.87,0,0,0,2.86-2.86v-4.48a2.87,2.87,0,0,0-2.86-2.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.48,124H372.7a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h10.78a.5.5,0,0,1,.5.5A.5.5,0,0,1,383.48,124Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.48,126.56H372.7a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h10.78a.5.5,0,0,1,.5.5A.5.5,0,0,1,383.48,126.56Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.49,129.07H372.7a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h7.79a.51.51,0,0,1,.5.5A.5.5,0,0,1,380.49,129.07Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cloud--inject-102"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.56,
    y: 180.3,
    width: 41.43,
    height: 41.43,
    rx: 11.03,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,203.75c0,.45,0,2-.09,2.45H345.26c0-.22,0-1.58,0-1.81a7.11,7.11,0,0,1,6.43-7.08V197a8.34,8.34,0,0,1,16.28-2.52,10.31,10.31,0,0,1,1.48.15A9.24,9.24,0,0,1,377,203.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mail--inject-102"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.28,
    y: 256.47,
    width: 41.37,
    height: 41.37,
    rx: 11.01,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.28,
    y: 256.47,
    width: 41.37,
    height: 41.37,
    rx: 11.01,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "391.56 272.99 391.56 284.89 366.37 284.89 366.37 272.89 378.71 280.93 391.56 272.99",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.56 270.57 391.56 270.74 378.71 278.67 366.37 270.63 366.37 270.57 391.56 270.57",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitaltoolsRafiki);
export default __webpack_public_path__ + "static/media/Digital tools-rafiki.e626a278b2ee925a7ed4feb672798686.svg";
export { ForwardRef as ReactComponent };